import BillingAddressCards from "../../../common/BillingAddressCards"
import ShippingAddressCards from "../../../common/ShippingAddressCards"
import { checkPermissions } from "../../../utils"


const AddressSelection = (props) => {
    const {
        buyerReqId,
        requirement,
        billingAddresses,
        handleBillingAddress,
        shippingAddresses,
        handleShippingAddress,
        setVisibleAddNewShippingAddr,
        userDetails
    } = props

    const {isPermitted: canAddNewShipAddress} = checkPermissions({ ...userDetails, userRoleId: userDetails.activeRoleId, permissions: [210] })

    return (
        <div className="p-card pb-1">
            <div className='post-req-component'>
                <h5 className="text-800 mt-2 text-sm"><span>Billing Address</span><span className="required-mark">*</span></h5>
                {requirement.gstinId && billingAddresses.length === 0 ?
                    <p className='mb-2 mt-0 ml-2 font-semibold billing-address-msg text-700 text-red-400'>Billing addressses are not available. Please contact tech support</p> :
                    <div className=''>
                        <BillingAddressCards billingAddresses={billingAddresses} selectedAddressId={requirement.billAddrId} handleBillingAddress={handleBillingAddress} disabled={buyerReqId}/>
                    </div>
                }
                <div className='hr-line'></div>
                <h5 className="text-600 mt-3 text-sm text-800"><span>Shipping Address</span><span className="required-mark">*</span></h5>
                <div className=''>
                    <div>
                        <ShippingAddressCards
                            shippingAddresses={shippingAddresses}
                            selectedAddressId={requirement.shipAddrId}
                            handleShippingAddress={handleShippingAddress}
                            showAddShipAddr={(requirement.shipAddrId === null && shippingAddresses.length > 0) && requirement.orderTypeId !== 3 && canAddNewShipAddress}
                            setVisibleAddNewShippingAddr={setVisibleAddNewShippingAddr}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AddressSelection